import React from 'react';

export const ArrowDownFilled = ({ className }: { className?: string }) => (
  <svg className={className} width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.83205 8.25192C6.43623 8.84566 5.56377 8.84566 5.16795 8.25192L1.03647 2.0547C0.593431 1.39015 1.06982 0.5 1.86852 0.5H10.1315C10.9302 0.5 11.4066 1.39015 10.9635 2.0547L6.83205 8.25192Z"
      fill="currentColor"
    />
  </svg>
);
